import { z } from 'zod';

// TradingView resolutions are strings such as "1", "10S", and "1D". They are
// not ISO-8601 periods, so the workspace wire representation stays a string.
export const tradingViewChartWidgetStateSchema = z.object({
    symbol: z.string().default('SPY'),
    chartState: z
        .custom<object>(
            (value) =>
                typeof value === 'object' &&
                value !== null &&
                !Array.isArray(value) &&
                z.json().safeParse(value).success,
        )
        .optional(),
    interval: z.string().optional(),
    timezone: z.string().optional(),
});

export type TradingViewChartWidgetState = z.output<typeof tradingViewChartWidgetStateSchema>;
